// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__23dSU","Pointer":"Card_Pointer__Sa4kL"};